<div class="container-fluid mt-2" style="height: 100vh;">
  <div class="row">
    <!-- Contenedor Izquierdo -->
    <div [class.col-md-8]="isRContainersVisible" [class.col-md-12]="!isRContainersVisible">
      <!-- Contenedor Superior Izquierdo -->
      <div class="p-3 rounded">
        <!-- style="height: 40vh; overflow-y: auto;" -->
        <div class="d-flex justify-content-end align-items-center mb-3">
          <button class="btn btn-primary btn-sm" (click)="toggleRContainers()">
            <i [class]="isRContainersVisible ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
          </button>
        </div>

        <div class="row mb-3 ">
          <div class="col-md-3">
            <label for="filterPeriod" class="form-label fw-bold">Periodo </label>
<!--             <label *ngIf="reportFindedById" for=""> Reporte encontrado</label> -->           
              <select id="filterPeriod" class="form-select" [(ngModel)]="selectedPeriod" (change)="onPeriodChange()">
              <option value="" disabled selected>Seleccione un periodo</option>
              <option *ngFor="let period of periods" [ngValue]="period">
                {{ period.name }}
              </option>
            </select>
          </div>
          <div class="col-md-2 py-3">
            <button class="button btn btn-primary btn-sm w-100" [disabled]="existingReport || !selectedPeriod"
              (click)="saveReportResponse()">Crear Informe</button>
          </div>
          <div class="col-md-2 py-3">
            <button class="button btn btn-success btn-sm w-100" (click)="sendReportResponse()"
              [disabled]="!userCanSend">Enviar
              Informe</button>
          </div>
         <!--  botón para descargar reporte -->
           <div *ngIf="reportResponseState=='67bf3798e343839c29db3a45'|| reportResponseState=='6841ef4ff4f90fb64f363a15'" class="col-md-2 py-3"> 
            <button class="button btn btn-secondary btn-sm w-100" (click)="generatePdfReport()">Resumen de Informe</button>
           </div>

          <div class="col-md-3" *ngIf="userCode!=''">
            Usuario: <strong>{{userCode}} - {{ userName }}</strong> 
          </div>
        </div>

        <div *ngIf="existingReport"><app-list-concepts ></app-list-concepts></div>

      </div>

      <!-- Contenedor Inferior Izquierdo -->
      <div *ngIf="existingReport" class="p-3 rounded ">
<!--         style="height: 20vh; overflow-y: auto;" --> 
       <app-list-discounts></app-list-discounts>
      </div>

      <div *ngIf="existingReport" class="p-3 rounded mb-2" >
        <!-- style="height: 13vh;" -->
        <app-report-totalizer></app-report-totalizer>
      </div>

  
      <div *ngIf="existingReport" class="p-3 rounded" >
        <!-- style="height: 35vh; overflow-y: auto;" -->
        <app-report-history></app-report-history>
      </div>

      <div *ngIf="existingReport && userRole=='Administrador' && userCanEdit" class="p-3 rounded mb-3" >
        <!-- style="height: 20vh; overflow-y: auto;" -->
        <app-report-review-w-comment></app-report-review-w-comment>
      </div>

    </div> <!--  Cierre Contenedor Izquierdo -->

    <!-- Contenedores Derechos -->
    <div *ngIf="isRContainersVisible" class="col-md-4">
      <div class="row">
        <!-- Contenedor Inferior Derecho -->
        <div class="col-12 mb-3">
          <app-list-votes></app-list-votes>
        </div>
        <!-- Contenedor Inferior Derecho 2 -->
        <div class="col-12">
          <app-calculator></app-calculator>
        </div>
      </div>
    </div>
  </div>
</div>